<template>
  <div class="breadcrumb-box">
    <div class="breadcrumb-box-route">
      <template v-for="(item, index) in breadcrumbData">
        <router-link
          v-if="item.isRoute"
          :class="[
            'breadcrumb-box-nav',
            { arrow: index !== breadcrumbData.length - 1 },
          ]"
          :key="`${item.name}${index}`"
          :to="item.to"
          ><img v-if="index == 0" class="site-icon" src="@/assets/image/site-icon.png" />{{ item.name }}<img class="next-icon" src="@/assets/image/next-icon.png" /></router-link
        >
        <div v-else class="breadcrumb-box-label" :key="`${item.name}${index}`">
          {{ item.name }}
        </div>
      </template>
    </div>
    <Button v-if="toBack" class="border-F85A36 wd-100 hg-40 radius-40 ml-20" @click="$router.go(-1)">返回</Button>
  </div>
</template>
<script>
export default {
  name: "breadcrumb",
  props: {
  },
  computed: {
    breadcrumbData() {
      return this.$route.meta.breadcrumbData;
    },
    toBack(){
      return this.$route.meta.toBack;
    }
  },
  methods:{
    onMenuChange(value){
      switch (value) {
        case "my":
          if(this.$route.name !== 'my'){
            this.$router.push('/my');
          }
          break;
        case "domain":
          if(this.$route.name !== 'domain'){
            this.$router.push('/my/domain');
          }
          break;
        case "finance":
          if(this.$route.name !== 'financeAccount'){
            this.$router.push('/my/finance/account');
          }
          break;
        case "user":
          if(this.$route.name !== 'user'){
            this.$router.push('/my/user');
          }
          break;
        
      }
    }
  },
};
</script>
<style lang="less" scoped>
.breadcrumb-box {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  .flex(space-between, center);
  .breadcrumb-box-route {
    .flex(space-between, center);
    .breadcrumb-box-nav {
    .flex(center, center);
      color: #707273;
      font-size: 16px;
      font-weight: 400;
      line-height: 21px;
    }
    .breadcrumb-box-label {
      font-size: 16px;
      color: #fff;
    }
  }
  .next-icon{
    width: 16px;
    height: 16px;
    margin: 0 8px;
  }
  .site-icon{
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}
</style>